import { useState, useEffect } from 'react';

// Viewport-width detection. Re-evaluates on resize / rotation so the app
// hot-swaps between desktop and mobile layouts without a reload.
// Threshold is a deliberate call — 768 catches phones in portrait AND
// landscape; tablets (iPad @ 810+) stay on the desktop layout.
const MOBILE_MAX_W = 768;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX_W,
  );
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_MAX_W);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}
